import { render, staticRenderFns } from "./PagamentoDetalhar.vue?vue&type=template&id=04ea4b35"
import script from "./PagamentoDetalhar.vue?vue&type=script&lang=js"
export * from "./PagamentoDetalhar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports